import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=25d2c02f&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=25d2c02f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2c02f",
  null
  
)

export default component.exports